import React from 'react'
import {get} from 'lodash'
import DateTime from 'containers/dateTime'

export const getColumnDefinition = () => {
  return {
    timestamp: {
      key: 'timestamp',
      label: 'Date',
      size: 100,
      visible: true,
      data: e => {
        return <DateTime date={get(e, 'timestamp', null)} />
      },
      order: 0,
    },
    contactName: {
      key: 'contactName',
      label: 'User',
      size: 100,
      visible: true,
      data: e => get(e, 'contactName', null),
      order: 1,
    },
    changeText: {
      key: 'changeText',
      label: 'Change',
      size: 100,
      visible: true,
      data: e => get(e, 'changeText', null),
      order: 2,
    },
  }
}

export const createNewHistoryItem = (item) => {
  return {
    ...item,
  }
}
